import { DateTime } from 'luxon';
import { makeAutoObservable } from 'mobx';
import { UserApi, UserApiResponse, UserPermission } from '../../api/UserApi';
import { UserType } from '../../config/Constants';

export type UserGroup = {
  groupId: number;
  permission: UserPermission;
};

export class User {
  id: number = 0;
  email: string = '';
  forename: string = '';
  surname: string = '';
  username: string = '';
  groups: UserGroup[] = [];
  hash: string = '';
  externalId: string = '';
  acceptedDocs: DateTime = null;
  type: UserType = UserType.USER;

  constructor() {
    makeAutoObservable(this);
  }

  static fromApi(apiData: UserApiResponse): User {
    const user = new User();
    user.id = apiData.id;
    user.email = apiData.email;
    user.forename = apiData.forename;
    user.surname = apiData.surname;
    user.groups = [];
    user.hash = apiData.hash;
    user.externalId = apiData.externalId;
    user.acceptedDocs = apiData.acceptedDocs
      ? DateTime.fromISO(apiData.acceptedDocs)
      : null;
    user.type = apiData.type as UserType;
    return user;
  }

  get hasAcceptedTerms() {
    return this.acceptedDocs !== null;
  }

  get isSupportUser() {
    return this.type == UserType.SUPPORT;
  }

  acceptDocs = () =>
    UserApi.acceptDocs(this.id).then((apiData: UserApiResponse) => {
      this.acceptedDocs = apiData.acceptedDocs
        ? DateTime.fromISO(apiData.acceptedDocs)
        : null;
    });

  addGroup = (groupId: number, permissions: UserPermission) => {
    this.groups.push({
      groupId: groupId,
      permission: permissions,
    });
  };
}
